import React from 'react';
import ReactDOM from 'react-dom/client';
import './tailwind.css';
import './index.css';
import { GlobalProvider } from './context/GlobalContext';
import App from './App';
import { Amplify } from 'aws-amplify';

Amplify.configure({
	aws_project_region: 'us-east-1',
	aws_cognito_identity_pool_id: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	// <React.StrictMode> // Should only be enabled during development
	<GlobalProvider>
		<App />
	</GlobalProvider>
	// </React.StrictMode>
);
